import type { EventContentObjectDetail } from 'models';
import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon, Modal, message } from 'ui';
import { useDeleteProgramEventMutation } from '../queries';

export const useDeleteEvent = ({ onEventDeleted }: { onEventDeleted?: () => void }) => {
  const { t } = useTranslation();
  const [modal, contextHolder] = Modal.useModal();
  const { mutateAsync: deleteEvent } = useDeleteProgramEventMutation();

  const confirm = useCallback(
    ({ eventContentObject }: { eventContentObject: EventContentObjectDetail }) => {
      const handleDeleteEvent = async () => {
        await deleteEvent(
          { eventId: eventContentObject.event.id },
          {
            onSuccess() {
              message.success('Event successfully deleted.');
              onEventDeleted?.();
            },
          },
        );
      };

      modal.confirm({
        content: 'This action is irreversible!',
        icon: <Icon color="error" icon="delete-2-line" />,
        okText: 'Delete',
        onOk: handleDeleteEvent,
        title: t('Are you sure you want to delete {{name}}?', { name: eventContentObject.event.name }),
        type: 'error',
      });
    },
    [deleteEvent, modal, onEventDeleted, t],
  );

  return useMemo(() => ({ confirm, contextHolder }), [confirm, contextHolder]);
};
